import localStorageIds from '../constants/localStorageIds'
import USER_PERMISSIONS from '../constants/userPermissions'
import localStorageHelper from './localStorageHelper'

// Whether the server allows `permission` in the selected org, or in any of `orgIds` when
// given (the orgs of the teams being acted on). Permissions are per org, from /users/me. A Manager
// limited to some competitions holds theirs per competition: they count here too, since everything
// such a Manager is shown (the server narrows every list) sits in their competitions. For an action
// on the org as a whole (creating or deleting a competition), pass `{ orgWide: true }`: only the
// org's own permissions count.
const hasPermission = (permission, orgIds, { orgWide = false } = {}) => {
  if (permission === USER_PERMISSIONS.ALL) return true

  const { localStorageValue: permissions } = localStorageHelper(localStorageIds.ORG_PERMISSIONS)
  if (!permissions) return false
  const { localStorageValue: competitionPermissions } = localStorageHelper(localStorageIds.COMPETITION_PERMISSIONS)

  // The stored org is large for a federation (it embeds every team), so read it only when needed.
  const candidates = orgIds?.length ? orgIds : [localStorageHelper(localStorageIds.SELECTED_ORG).localStorageValue?.id]
  return candidates.some(
    (orgId) =>
      orgId &&
      (permissions[orgId]?.includes(permission) ||
        (!orgWide && Object.values(competitionPermissions?.[orgId] || {}).some((held) => held.includes(permission)))),
  )
}

// Before /users/me has answered for this session nothing can be decided yet.
export const permissionsLoaded = () =>
  !!localStorageHelper(localStorageIds.ORG_PERMISSIONS).localStorageValue

export default hasPermission
